import { Component, Input } from '@angular/core';
import { BaseModal } from '../base-modal';

@Component({
    selector: 'ui-info-modal',
    templateUrl: './info-modal.component.html',
    styleUrls: ['./info-modal.component.less']
})
export class InfoModalComponent extends BaseModal {

    @Input() title : string = '';
    @Input() description : string = ''; 
    @Input() buttonsTitle = {
        confirm: 'OK'
    };
}